import { classes } from 'html-classes';
import { type JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import { MobileActionDialog } from '~/components/MobileActionDialogV3';
import BottomNavigationBarV2 from '~/pages/Root/BottomNavigationBar/BottomNavigationBarV2';
import eventEmitter, { EventsName } from '~/services/Events';
import { bottomNavigationStore } from '~/stores/BottomNavigationStore';

import type { MobileFiltersProps } from './interfaces';
import styles from './MobileFilters.module.scss';

const MobileFilters = (props: MobileFiltersProps): JSX.Element => {
  const { open, onClose, onReset, onApply, className, children } = props;

  const { t } = useTranslation();

  useEffect(() => {
    bottomNavigationStore.setFilters(!!open);
  }, [open]);

  useEffect(() => {
    eventEmitter.on(EventsName.APPLY_FILTERS, () => {
      onApply?.();
    });

    eventEmitter.on(EventsName.RESET_FILTERS, () => {
      onReset?.();
    });

    return () => {
      eventEmitter.off(EventsName.APPLY_FILTERS);
      eventEmitter.off(EventsName.RESET_FILTERS);
    };
  }, [open]);

  return (
    <MobileActionDialog
      open={open}
      onClose={onClose}
      className={className}
      contentHeight="100%"
      title={
        <>
          <h2 className={styles.headerTitle}>{t('filter')}</h2>
        </>
      }
      footer={
        company.newDesignSystemEnabled ? (
          <BottomNavigationBarV2 isInModal />
        ) : (
          <>
            <button
              type="button"
              className="button _bordered"
              onClick={onReset}
            >
              {t('resetAll')}
            </button>
            <button
              type="button"
              className={classes(['button', '_primary', styles.applyButton])}
              onClick={onApply}
            >
              {t('applyFilters')}
            </button>
          </>
        )
      }
    >
      {children}
    </MobileActionDialog>
  );
};

export default MobileFilters;
